module.exports = __webpack_public_path__ + "img/Move(Button).73e1a54d.svg";